// External Dependencies
import Marionette from 'backbone.marionette';
import Backbone from 'backbone';

// Internal Dependencies - screens/views/templates
import  resourcesCompositeView  from '../../../../templates/Utilities/Resources/resourcesCompositeView';

// Internal Dependencies - models/collections

export default Marionette.ItemView.extend({

	tagName: 'div',

	className: 'resources-composite-view',

	initialize: function() {
		this.channel = Backbone.Radio.channel( 'AppChannel' );
		this.app = this.channel.request( 'app' );
		this.model.set('isApcm', this.app.controller.isApcm);

		this.listenTo( this.channel, 'set:isApcm', this.setIsApcm );
	},

	getTemplate: function() {
		return resourcesCompositeView( this.model );
	},

	setIsApcm: function() {
		this.model.set('isApcm', this.app.controller.isApcm);
		this.render();
	},

});
